import { tv } from 'tailwind-variants';

const collapseTransition =
  'grid transition-[grid-template-rows,opacity,margin] duration-400 ease-in-out';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-8',
    content: 'flex flex-col gap-6 pb-4 sm:gap-8',
    title: '',
    productTile: '',
    variants: '',
    sizeCollapse: collapseTransition,
    sizeCollapseInner: 'overflow-hidden',
    quantityCollapse: collapseTransition,
    quantityCollapseInner: 'overflow-hidden',
    quantitySection: 'flex w-full flex-col gap-3 sm:mt-3',
    quantityTitle: 'heading-m-regular sm:hidden',
    quantityInput: [
      'w-full sm:h-8 sm:w-26 sm:bg-transparent!',
      'sm:[&_button]:h-8 sm:[&_button]:w-8 sm:[&_button]:min-w-8',
      'sm:[&_input]:heading-m sm:[&_input]:min-w-0',
      'sm:[&_svg]:size-4',
      '[&_button:disabled]:text-disabled'
    ],
    quantityDesktop: 'max-sm:hidden',
    quantityMobile: 'sm:hidden',
    actions: 'flex gap-3 sm:max-w-80',
    footer: 'flex flex-col gap-3',
    footerDesktop: 'hidden sm:mt-2 sm:flex sm:flex-col',
    footerMobile:
      'bg-color-base -mx-4 mt-auto flex shrink-0 flex-col gap-3 border-t border-black/5 px-4 py-4 sm:hidden',
    addToCart: 'w-full',
    continueShopping: 'disabled:bg-color-tertiary! w-full',
    toCart: 'hidden sm:block',
    toCartMobile: 'block sm:hidden'
  },
  variants: {
    experiment: {
      true: {
        base: 'bg-color-base flex min-h-0 flex-1 flex-col gap-0',
        content:
          'flex min-h-0 flex-1 flex-col gap-6 overflow-x-hidden overflow-y-auto pb-4 sm:gap-8',
        title: 'heading-l-regular sm:heading-3xl sm:pr-15',
        productTile: 'mb-0 sm:pr-15',
        sizeCollapse: 'sm:pr-15',
        footerDesktop: 'hidden sm:mt-2 sm:flex sm:flex-col sm:pr-15',
        quantityMobile: 'sm:hidden sm:pr-15'
      },
      false: {
        title: 'heading-l-regular sm:heading-2xl-desk'
      }
    },
    visible: {
      true: {
        sizeCollapse: 'mb-0 grid-rows-[1fr] opacity-100',
        quantityCollapse: 'mb-0 grid-rows-[1fr] opacity-100'
      },
      false: {
        sizeCollapse: 'pointer-events-none -mb-6 grid-rows-[0fr] opacity-0 sm:-mb-8',
        quantityCollapse:
          'pointer-events-none grid-rows-[0fr] opacity-0 max-sm:-mb-6 sm:-mt-2'
      }
    }
  },
  defaultVariants: {
    experiment: false,
    visible: true
  }
});
